export class AssignActionPost {
    assignTo: string;
}
